<template>
  <div class="auth-card-wrapper">
    <div class="auth-card">
      <div class="auth-card-container">
        <img
          class="logo"
          alt="logo"
          src="@/assets/nubuilder.svg"
        />
        <h3 class="text-title mb-2">Confirm your new account</h3>
        <p class="reset-password-description">
          An email has been sent to you with a registration code. Please <br/>
          confirm your account by entering the registration code below.
        </p>
      </div>

      <v-form ref="form" v-model="valid">
        <div class="auth-card-container form-fields" style="margin-bottom: 8px">

          <v-text-field
            label="Email"
            type="email"
            v-model="username"
            :rules="[rules.required, rules.email]"
            validate-on="blur"
            variant="outlined"
            density="default"
          ></v-text-field>

          <v-text-field
            label="Enter your registration code"
            id="code"
            v-model="code"
            :rules="[rules.required]"
            validate-on="blur"
            v-on:keyup.enter="submit"
            variant="outlined"
            density="default"
          ></v-text-field>

          <v-row class="my-0">
            <v-col class="pa-0">
              <p class="bg-error" v-html="error"/>
            </v-col>
          </v-row>

          <div class="d-flex justify-center auth-card-container">
            <v-btn
              min-width="180px"
              rounded="lg"
              size="large"
              color="#363a40"
              class="d-flex"
              variant="flat"
              @click="submit"
            >
              Confirm
            </v-btn>
          </div>

          <v-divider></v-divider>

          <div class="auth-card-footer-part">
            <div class="auth-card-footer">
              <p class="text">
                Already have an account?
                <router-link
                  class="text text-decoration-none"
                  tabindex="5"
                  :to="{ path: '/login'}"
                >
                  <span class="light--text">Login</span>
                </router-link>
              </p>
            </div>
          </div>
        </div>
      </v-form>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      valid: true,
      email: '',
      code: '',
      error: null,
      message: null,
      username: '',
      rules: {
        required: (value) => !!value || 'Required.',
        email: (value) => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
          return pattern.test(value) || 'Invalid e-mail.'
        }
      },
      e1: true
    }
  },
  created () {
    if (this.$route.query.username !== '') {
      this.username = this.$route.query.username
    }
  },
  methods: {
    async submit () {
      const { valid } = await this.$refs.form.validate()
      if (valid) {
        const code = this.code.trim()

        this.$cognitoAuth.confirmRegistration(this.username, code, (err, result) => {
          if (err) {
            this.error = err.message
            console.error(err)
          } else {
            this.$router.replace({
              path: '/login',
              query: {
                thanks: true,
                username: this.username,
                projectId: this.$route.query.projectId || undefined
              }
            })
          }
        })
      }
    }
  }
}
</script>

<style scoped>
.text {
  font-size: 13px;
  margin-bottom: 0;
  line-height: 14.3px;
}

.logo {
  width: 110px;
  height: 48px;
  margin-bottom: 24px;
}

.form-fields {
  gap: 12px;
  display: flex;
  flex-direction: column;
}

.message {
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 16px;
}
</style>
